import React, { 
  useEffect, 
  useContext, 
  useRef
 } from 'react';
import styled from 'styled-components';
import { HelpersComponent } from '../../components';
import {  StoryBg, } from '../../assets/img';
import { NavButton } from '../../styles';
import { RelationsHeroContext } from '../../contexts/hero'
import { HERO_FAILURE, HERO_REQUEST, HERO_SUCCESS, PRESS_FAILURE, PRESS_REQUEST, PRESS_SUCCESS } from '../../constants';
import api from '../../services/api';
import { PressContext } from '../../contexts/blog';
import { Screen } from '../../styles'

// const Navigation = NavigationBar.Navigation;
const ComponentLoader = HelpersComponent.dashboardLoader;
const Dormant = () => {
  const mount = useRef()
  const { dispatch, state } = useContext(RelationsHeroContext)
  const { dispatch: pressDispatch, state: pressState } = useContext(PressContext)
 
  useEffect(() => {
    mount.current = true
    //Scroll to top on page load
    window.scrollTo(0, 0);

    // get Hero
    const getHero = async () => {
      try {
        if(state.data.length < 1){
          dispatch({ type: HERO_REQUEST })
          const result = await api.req('/api/document/hero/relations')
          dispatch({
            type: HERO_SUCCESS,
            payload: JSON.parse(result.details.data)
          })
        }
      } catch (error) {
        dispatch({
          type: HERO_FAILURE,
          payload: error.response && error.response.result.responseMessage 
          ? error.response.result.responseMessage : error.responseMessage
        }) 
      }
    }
    getHero()


    return () => {
      mount.current = false
    };
  }, []);
  useEffect(() => {
    // get press articles
 const getPress = async () => {
  try {
    
    if(pressState.data.length < 1){
      pressDispatch({ type: PRESS_REQUEST})
      const result = await api.req('/api/document/press')
      pressDispatch({
        type: PRESS_SUCCESS,
        payload: JSON.parse(result.details.data)
      }) 
    }
    
  } catch (error) {
    pressDispatch({
      type: PRESS_FAILURE,
      payload: error.response && error.response.result.responseMessage 
      ? error.response.result.responseMessage : error.responseMessage
    }) 
  }
  }
  getPress()
  
  }, [])


  return (
    <Box>
      {
        state.loading ? <ComponentLoader /> : (
          <>
          <Section className='hero' bg={`url(${state.data[0]})`}>
            <Container className='hero'>
              <Glass>
                <Content className='glass'>
                  <h2>Dormant Account</h2>
                  <p>
                  Perform a quick search for your Abbey Mortgage Bank dormant account details.
                  </p>
                </Content>
                 <a href={'https://identity.abbeymortgagebank.com/dormant'} 
                  target='_blank' 
                  rel='noopener noreferrer'>
                  <OpenAccount>
                    Go to portal
                  </OpenAccount>
                </a>
              </Glass>
            </Container> 
          </Section>
          <TextContainer>
            <TextHeader>
             GUIDELINES ON MANAGEMENT OF DORMANT ACCOUNTS,
             UNCLAIMED BALANCES, AND OTHER FINANCIAL ASSETS IN BANKS AND 
             OTHER FINANCIAL INSTITUTIONS IN NIGERIA.
            </TextHeader>
            <TextDescription>
              Furtherance to the CBN guidelines on Management of Dormant Account and 
              Unclaimed Funds issued on 19 July 2024, balances of dormant current, savings, term 
              deposits accounts that have remained with the Bank for a period of ten (10) years and 
              beyond with no customer induced transactions is required to be sent to the Central Bank of Nigeria.
            </TextDescription>
            <TextBodyHeader>
              PROCEDURES TO RECLAIM UNCLAIMED BALANCES
            </TextBodyHeader>
            <TextBody>
              The following are the procedures to reclaim unclaimed balances moved from eligible dormant accounts without transaction over 10 years:
              <br></br>
              <br></br>
                   1.	The account owners/beneficiary can access the list of unclaimed balances on our website by clicking  
                   <a href={'https://identity.abbeymortgagebank.com/dormant'}                   
                      target='_blank' 
                      rel='noopener noreferrer'
                   >
                    <Here> here </Here>  </a>
                    <br></br>
                    <br></br>
                   2.	The account owner/beneficial owner shall visit any of our branches and complete an ‘Asset Reclaim Form’.
                    Customers are to provide the below supporting documents in addition to the completed form.
                    <br></br>
                    <br></br>
                    <Bullet>                   
                       <ul>
                      <li> Evidence of account ownership </li>
                      <li> Valid means of identification </li>
                      <li> Evidence of present place of residence (Recent Utility Bill) </li>
                      <li> Affidavit on the accuracy of the information to reactivate the account. </li>
                  </ul>
                    </Bullet>
                   <br></br>
                   <p> Additional information for Corporate Accounts </p>
                   <br></br>
                     <Bullet>                   

                    <ul>
                     <li> Satisfactory Legal Search</li>
                   </ul>
                    </Bullet>
                     <br></br>
                   3.	The Asset Reclaim from the Central Bank of Nigeria will commence upon receipt and validation of supporting documents and should be received within ten working days for further credit into the Abbey account.
                    <br></br>
                    <br></br>
                   For further questions/enquiries, kindly reach out to our Customer Experience Team on 02012271695, 09134444840 for Calls and WhatsApp respectively or email to
                   <br></br>
                   <br></br>
                   <MailTo>
                   <a href="mailto:example@email.com"> customerexperience@abbeymortgagebank.com </a>
                   </MailTo>
              </TextBody>
            </TextContainer>
          </>
        )
      }
    </Box>
  );
};

const Box = styled.div`
  width: 100%;
  min-height: 100vh;
  // background-color: #fff;
`;
const Container = styled.div`
  width: 75%;
  margin: 10rem auto 0;
  &.hero {
    margin: 0 auto;
    display: flex;
    justify-content: flex-start;
    width: 85%;
    ${Screen.miniLargeScreen`
    padding-top: 5rem;
    `}
    ${Screen.mediumpc`
    padding-top: 7rem;
    `}
    ${Screen.smallpc`
    padding-top: 0;
    `}
     ${Screen.tablet`
    display: flex;
    justify-content: center;
    align-items: center;
    `}
    ${Screen.mediumPhone`
    width: 100%;
    margin: 0!important;
    padding-top: 4.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    `}
    ${Screen.phone`
    width: 100%;
    margin: 0!important;
    display: flex;
    justify-content: center;
    align-items: center;
    `}
    ${Screen.smallPhone`
    width: 100%;
    margin: 0!important;
    display: flex;
    justify-content: center;
    align-items: center;
    `}
  }
  ${Screen.miniLargeScreen`
  width: 90%;
  margin: 5rem auto;
  `}
  ${Screen.pad`
  width: 80%;
  margin: 5rem auto;
  `}
  ${Screen.mediumpc`
  width: 80%;
  margin: 7rem auto;
  `}
  ${Screen.smallpc`
  width: 70%;
  margin: 5rem auto!important;
  `}
  ${Screen.tablet`
  width: 70%;
  margin: 5rem auto!important;
  `}
  ${Screen.surfaceDuo`
  width: 80%;
  margin: 3rem auto!important;
  `}
  ${Screen.mediumPhone`
  width: 90%;
  margin: 3rem auto!important;
  `}
  ${Screen.phone`
  width: 90%;
  margin: 3rem auto!important;
  `}
  ${Screen.smallPhone`
  width: 90%;
  margin: 3rem auto!important;
  `}
`;

const Glass = styled.div`
  width: 540px;
  height: 270px;
  background: rgba(217, 217, 217, 0.5);

  ${Screen.mediumpc`
  height: 230px;
  `}
  ${Screen.tablet`
  height: 230px;
  `}
  ${Screen.surfaceDuo`
  width: 90%;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  `}
  ${Screen.mediumPhone`
  width: 90%;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  `}
  ${Screen.phone`
  width: 90%;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  `}
  ${Screen.smallPhone`
  width: 90%;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  `}
`;

const Button = styled(NavButton)`
  width: 7rem;
  height: 2rem;
  border-radius: 5px;
  margin: 1.5rem 0;
  margin-right: ${({ mr }) => mr};
  background-color: #002668;
  ${Screen.mediumPhone`
  width: max-content;
  height: 1.5rem;
  padding: 0 .5rem;
  font-size: .8rem;
  margin: 0 0 .5rem;
  `}
  ${Screen.phone`
  width: max-content;
  height: 1.5rem;
  padding: 0 .5rem;
  font-size: .8rem;
  margin: 0 0 .5rem;
  `}
  ${Screen.smallPhone`
  width: max-content;
  height: 1.5rem;
  padding: 0 .5rem;
  font-size: .8rem;
  margin: 0 0 .5rem;
  `}
`;

const OpenAccount = styled(Button)`
  width: 10rem;
  height: 2.5rem;
  border-radius: 5px;
  margin: 3rem 0 0;
  margin-left: 2rem;
  /* margin-right: ${({ mr }) => mr}; */
  background-color: #c81e19;
  box-shadow: 1px 2px 5px #666;
  ${Screen.mediumpc`
  margin: 2rem 0 0 2rem;
  `}
  ${Screen.tablet`
  margin: 2rem 0 0 2rem;
  `}
  ${Screen.surfaceDuo`
  width: max-content;
  height: 2rem;
  padding: .5rem;
  margin: .5rem 0;
  `}
  ${Screen.mediumPhone`
  width: max-content;
  height: 2rem;
  padding: .5rem;
  margin: .5rem 0;
  `}
  ${Screen.phone`
  width: max-content;
  height: 2rem;
  padding: .5rem;
  margin: .5rem 0;
  `}
  ${Screen.smallPhone`
  width: max-content;
  height: 2rem;
  padding: .5rem;
  margin: .5rem 0;
  `}
`;

const  TextContainer = styled.div `
width: 80%;
margin: auto;
margin-top: 80px;
`

const  TextHeader = styled.p `
font-size: 16px;
font-weight: bold;
color: #0842A6;
`

const  TextDescription = styled.p `
font-size: 16px;
margin: 20px 0px;
`

const  TextBodyHeader = styled.p `
font-size: 16px;
font-weight: bold;
color: #0842A6;
`

const Here = styled.span`
font-size: 16px;
font-weight: bold;
color: #0842A6;
text-decoration: underline;
`

const  TextBody = styled.p `
font-size: 16px;
margin: 20px 0px;`

const Bullet = styled.div `
 margin-left: 3%;
`

const MailTo = styled.div `
font-size: 16px;
font-weight: bold;
text-decoration: underline;
a {
color: #0842A6;
}

${Screen.surfaceDuo`
font-size: 13px;
  `}
`

const Section = styled.section`
  width: 100%;
  min-height: 100vh;
  &.hero {
    /* background-image: url(${StoryBg}); */
    background-image: ${({ bg }) => bg};
    background-position: center;
    background-size: cover;
    margin-top: 80px;
    padding-top: 13rem;
    ${Screen.tablet`
    min-height: 50vh!important;
    `}
    ${Screen.mediumpc`
    min-height: 50vh!important;
    `}
    ${Screen.smallpc`
    min-height: 30vh!important;
    margin-top: 5rem!important;
    padding-top: 1rem;
    `}
     ${Screen.tablet`
    min-height: 40vh!important;
    margin-top: 5rem!important;
    padding-top: 4rem;
    `}
     ${Screen.surfaceDuo`
    min-height: 30vh!important;
    margin-top: 5rem!important;
    padding-top: 4rem;
    `}
    ${Screen.mediumPhone`
    min-height: 30vh!important;
    margin-top: 5rem!important;
    padding-top: 4rem;
    `}
    ${Screen.phone`
    min-height: 30vh!important;
    margin-top: 5rem!important;
    padding-top: 4rem;
    `}
    ${Screen.smallPhone`
    min-height: 30vh;
    margin-top: 5rem!important;
    padding-top: 4rem;
    `}
  }
  &.browse {
    ${Screen.mediumpc`
    min-height: 60vh!important
    `}
    ${Screen.smallpc`
    min-height: 70vh!important
    `}
  }
  &.banner {
    width: 100%;
    min-height: 60vh;
    margin-top: 5rem;
    margin-bottom: 0;
  }

  &.announcement {
    width: 100%;
    min-height: 40vh;
    margin-top: 5rem;
  }
  &.governance {
    width: 100%;
    min-height: 100vh;
    margin: 3rem 0 0 5rem;
  }
  &.analyst,
  &.financial,
  &.shareholder {
    width: 100%;
    min-height: 100vh;
    margin: 3rem 0 0 5rem;
  }
`;

const Content = styled.div`
  padding-left: 2rem;
  ${Screen.phone`
  padding-left: 0;
  `}
  ${Screen.smallPhone`
  padding-left: 0;
  `}
  &.glass {
    h2 {
      padding-top: 3rem;
      font-size: 45px;
      color: #002668;
      ${Screen.mediumpc`
      font-size: 30px;
      `}
      ${Screen.tablet`
      font-size: 30px;
      `}
      ${Screen.surfaceDuo`
      padding-top: 2rem;
      font-size: 28px;
      text-align: center;
      `}
      ${Screen.mediumPhone`
      padding-top: 2rem;
      font-size: 28px;
      text-align: center;
      `}
      ${Screen.phone`
      padding-top: 2rem;
      font-size: 24px;
      text-align: center;
      `}
      ${Screen.smallPhone`
      padding-top: 2rem;
      font-size: 24px;
      text-align: center;
      `}
    }

    p {
      color: #fff;
      padding-top: 0.5rem;
      text-align: left;
      font-size: 18px;
      text-shadow: 3px 3px 3px #666;
      ${Screen.mediumpc`
      color: #002668;
      text-shadow: none;
      `}
      ${Screen.smallpc`
      color: #002668;
      text-shadow: none;
      font-size: 16px;
      `}
      ${Screen.tablet`
      color: #002668;
      text-shadow: none;
      `}
      ${Screen.surfaceDuo`
      font-size: 16px;
      text-align: center;
      text-shadow: none;
      color: #002668 ;
      padding: .5rem;
      `}
      ${Screen.mediumPhone`
      font-size: 16px;
      text-align: center;
      text-shadow: none;
      color: #002668 ;
      padding: .5rem;
      `}
      ${Screen.phone`
      font-size: 14px;
      text-align: center;
      text-shadow: none;
      color: #002668 ;
      padding: .5rem;
      `}
      ${Screen.smallPhone`
      font-size: 14px;
      text-align: center;
      text-shadow: none;
      color: #002668 ;
      padding: .5rem;
      `}
    }
  }
`;


export default Dormant;
